<template>

    <div class="w-full h-full flex flex-col  gap-2 p-4 bg-[#5D5D98] rounded-[10px] bg-opacity-[0.55] text-white">
        <div class="w-full flex gap-2">
            <AppButton :visibility="true" emitType="select" left_icon="fa-solid fa-circle-plus fa-2xl"
                @select="create_entity(data.entity)" :font_size="12" color="#9797EF" :text="'novo/a ' + data.entity" />

            <AppButton :visibility="true" emitType="select" @select="list_entities(data.entity)" :font_size="12"
                :color="!show_entity_list?'#9797EF':'#ff9b05'" :text="!show_entity_list?'Listar ' + data.entity + 's':'Adicionar items'" />

            <!-- <h3 class="text-[#ff9b05]">Produto</h3> -->
            <AppButton class="self-end text-white ml-auto" v-bind:visibility="true"
                left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @close="close" :width=23 :height=23 />
        </div>

        <div class="up_container flex gap-2 ">
            <div class="left flex flex-col gap-2">

                <AppButton :visibility="true" emitType="select" @select="clear_inputs" :font_size="12" color="#006698"
                    text="Limpar" />

                <div v-for="(value, key) in models_copy[model_type]" :key="key">
                    <div v-if="key !== 'id'" class="flex flex-col text-white">
                        <label :for="key">{{ key }}:</label>
                        <input class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
                            :type="getInputType(key, value)" v-model="models_copy[model_type][key]" :placeholder="key"
                            @input="handleInputChange(key)" :max="key === 'desconto' ? 1 : null"
                            :min="key === 'desconto' ? 0 : null" :step="key === 'desconto' ? 0.01 : null">
                        <!-- <label :for="key">{{ key }}:</label> -->
                        
                    </div>
                </div>

                <div class="set_data_container rounded-[10px] flex flex-col gap-2 p-2 bg-[#5d5d988c] ">
                    <div v-for="(value, key) in set_data_copy" :key="key">
                        <div class="ser_data flex gap-2 ">
                            <label class="" for="Iva">{{ key }}:</label>
                            <div class="text-[#ff9b05] min-w-[80px]">
                                {{ value.nome }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="button-container">
                    <div v-for="(value, key) in types" :key="key" class="button-wrapper">
                        <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" :text="key" emitType="select" @select="open_set_generic_table(key)" />
                    </div>
                </div>

                <AppButton v-bind:visibility="true" :font_size="12" color="#9797EF"
                    left_icon="fa-solid fa-pen-to-square" text="Equip" emitType="select"
                    @select="open_generic_table('equipamento')" />

                <!-- <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05"
                    left_icon="fa-solid fa-pen-to-square" text="Equip" emitType="select"
                    @select="open_generic_table('equipamento')" />
                <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05"
                    left_icon="fa-solid fa-pen-to-square" text="Serviços" emitType="select"
                    @select="open_generic_table('servico')" /> -->


                <!-- <div class="button-container">
                    <div v-for="(value, key) in types" :key="key" class="button-wrapper">
                        <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" :text="key" emitType="select" @select="open_generic_table(key)" />
                    </div>
                </div> -->
                <button class="bg-[#006698] text-white rounded-[10px] lg:max-w-40" @click.prevent="add_data">{{
                data_create ? 'Adicionar' : 'Atualizar' }}</button>
                <button v-if="!data_create" class="bg-[#a82222] text-white rounded-[10px] lg:max-w-40"
                    @click.prevent="delete_data">eliminar</button>
            </div>

            <div v-if="!show_generic_table" class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable :visibility="true" :show="true" :table_data="upTable_data" :table_title="model_type"
                    @row-clicked="select_upTable_data" :show_multiSelect="false" :page_display="5" @close="null" />
            </div>

            <div v-else class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable visibility="true" :show="show_generic_table"
                        :table_data="generic_table_data" :table_title="generic_table_title" @row-clicked="select_generic_data"
                        :show_multiSelect="false" :page_display="5" @close="show_generic_table=false" 
                /> 
            </div>
        </div>

        <div class="down_container flex gap-2">
            <div class="left flex flex-col gap-2 ">
                <AppInfoCard :data="infoCard_data" :title="'informação ' + indentityLabel" />
                <!-- chamar component infoCard -->
            </div>

            <div v-if="!show_entity_list" class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable :visibility="true" :show="!show_entity_list" :table_data="downTable_data"
                    :table_title="'Item ' + indentityLabel " @row-clicked="select_downTable_data" :show_multiSelect="false"
                    :page_display="5" @close="null" />
            </div>

            <div v-if="show_entity_list"  class="right flex flex-col p-2 w-full h-full">
                <AppTable :visibility="true" :show="show_entity_list" :table_data="entities"
                    :table_title="data.entity" @row-clicked="select_entity_data" :show_multiSelect="false"
                    :page_display="5" @close="null" />
            </div>

        </div>
    </div>

</template>


<script>

    import axios from 'axios';
    import AppTable from './tables/table.vue'
    import AppButton from './updated/button.vue'
    import AppAddressMap from './addressMap.vue'
    import AppInfoCard from './infoCard_final.vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'GenericIdentity',
        components: {
            AppButton,
            AppTable,
            AppAddressMap,
            AppInfoCard
        },
        props: {

            data: {
                type: Object,
                default: {}
            },

            models: {
                type: Array,
                default: []
            },
            types:{
                type:Object,
                default:{}
            },
            set_data:{
                type:Object,
                default:{}
            },
            set_id:{
                type:Object,
                default:{}
            },
            owners: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {

                models_copy: JSON.parse(JSON.stringify(this.models)),
                set_data_copy:JSON.parse(JSON.stringify(this.set_data)),
                infoCard_data: {
                    // nome:'',
                    // morada:'',
                    // email:'',
                    // telefone:'',
                },
                entity: {},
                entities:[],
                current_table_entity: {},
                current_table2_entity: {},
                data_create: true,
                show_entity_list: false,
                equipamentos: [],
                servicos: [],
                upTable_data: [],
                downTable_data: [],
                finalData: [],
                baseURl: process.env.VUE_APP_URL_BASE,
                model_type: 'equipamento',

                show_generic_table:false,
                generic_table_title:'',
                generic_table_data:[],

            }
        },
        created() {
            console.log("item", this.item)
            this.get_datas();
        },

        computed: {
            indentityLabel() {
                if (this.data.entity == 'faturafornecedor') {
                    return 'da fatura do fornecedor'
                }
                return `do/a ${this.data.entity}`
            },

            // finalFaturaData() {

            //     return this.models_copy['db_model']

            // }

        
        },


        methods: {


            getInputType(key, value) {
                return typeof value === 'number' ? 'number' : 'text';
            },

            async get_datas() {
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
                const equipamentos = await this.select_all(`${this.baseURl}/api/v1/equipamento/?custom=True`);
                const servicos = await this.select_all(`${this.baseURl}/api/v1/servico/?custom=True`);

                this.equipamentos = equipamentos?.sort((a, b) => a.id - b.id)
                this.servicos = servicos?.sort((a, b) => a.id - b.id)

                if (this.model_type == 'equipamento')
                    this.upTable_data = [...this.equipamentos]
                else
                    this.upTable_data = [...this.servicos]


                // if(isEmptyObject(this.data.data)){
                //     this.data_create=true;
                // }
                // else{
                //     this.items = [...this.data.data]
                // }

            },

            async add_data() {
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

                for (let key in this.set_data_copy) {

                    if(this.set_id.hasOwnProperty(key)){
                        this.models_copy[this.data.entity][this.set_id[key]]=this.set_data_copy[key].id

                    }

                }

                if (this.data_create){
                    if(isEmptyObject(this.entity)){
                        
                        let faturaData = this.models_copy[this.data.entity.toLowerCase()] 
                        console.log("faturaData:", faturaData);
                        
                        const res=await this.create(faturaData, `${this.baseURl}/api/v1/${this.data.entity.toLowerCase()}/registrar/`);
                        this.entity=JSON.parse(JSON.stringify(res))
                    }
                    this.copyValues();

                    

                    console.log("db_model:", this.models_copy['db_model']) 
                    // const create_data = {
                    //     ...this.models_copy['db_model'],
                    //     ...this.models_copy[this.data.entity]
                    // };
                    // console.log("create_data:", create_data)
                    // const res = await this.create(this.models_copy['db_model'], `${this.baseURl}/api/v1/item${this.data.entity.toLowerCase()}/registrar_${this.data.entity.toLowerCase()}/`);
                    // console.log("Data :", this.models_copy['db_model'])
                    // return
                    
                    let itemFaturaDa = this.models_copy['db_model']
                    console.log("itemFaturaDa:", itemFaturaDa);
                    

                    const res = await this.create(itemFaturaDa, `${this.baseURl}/api/v1/item${this.data.entity.toLowerCase()}/registrar/`);

                    if(res){
                        const entity=await this.select(`${this.baseURl}/api/v1/${this.data.entity.toLowerCase()}/${this.entity.id}/`);
                        console.log("entity:", entity)
                        this.infoCard_data=entity
                        this.downTable_data.push(res)

                        toast.success(`Item ${this.data.entity} criado com sucesso!`,{
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                        });

                    }

                    console.log("create")
                }
                else{

                    console.log("update")
                    this.copyValues();
                    console.log("db_model:", this.models_copy['db_model']) 
                    const res = await this.update(`${this.baseURl}/api/v1/item${this.data.entity.toLowerCase()}/editar/${this.current_table2_entity.id}/`, this.models_copy['db_model']);
                    if(res){
                        const entity=await this.select(`${this.baseURl}/api/v1/${this.data.entity.toLowerCase()}/${this.entity.id}/`);
                        console.log("entity:", entity)
                        this.infoCard_data=entity
                        this.downTable_data.find((item, index) => {
                            if (item.id === res.id) {
                                this.downTable_data[index] = res;
                                return true;
                            }
                        });

                        toast.success(`Item ${this.data.entity} atualizado com sucesso!`,{
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                        });
                    }

                }

                this.clear_inputs();

                //this.clear_inputs();
            },

            async select_upTable_data(item) {
                this.clear_inputs();
                this.current_table_entity = JSON.parse(JSON.stringify(item))
                console.log("current_table_entity:", this.current_table_entity)
                console.log("upTable_data:", item)
                if(this.data.entity!='proposta')
                    item?.venda? this.models_copy[this.model_type].valorUnitario=item.venda:0
                
                this.models_copy[this.model_type].quantidade=1

                this.calc_total()
            },

            async select_downTable_data(item) {
                //this.infoCard_data = item
                const res = await this.select(`${this.baseURl}/api/v1/item${this.data.entity.toLowerCase()}/${item.id}/`);
                if(res){
                    this.clear_inputs();
                    //console.log("res:", res)
                    this.current_table2_entity = JSON.parse(JSON.stringify(res))
                    //console.log("current_table_entity:", this.current_table_entity)
                    
                    this.data_create=false;
                    res?.venda? this.models_copy[this.model_type].preco=res.venda:0
                    res?.desconto? this.models_copy[this.model_type].desconto=res.desconto:0
                    res?.quantidade? this.models_copy[this.model_type].quantidade=res.quantidade:1
                    
                }
                
                console.log("downTable_data:", item)
            },

            async select_data(item) {
                console.log('table_item:', item)

            },

            async delete_data() {
                const res = await this.remove(`${this.baseURl}/api/v1/item${this.data.entity.toLowerCase()}/eliminar/${this.current_table2_entity.id}/`);
                if(res){
                    this.downTable_data = this.downTable_data.filter((item) => item.id !== this.current_table2_entity.id);
                    toast.success(`Item ${this.data.entity} eliminado com sucesso!`,{
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000,
                    });
                }


                this.clear_inputs();
            },

            clear_inputs() {
                this.models_copy = JSON.parse(JSON.stringify(this.models))
                this.current_table_entity = {}
                this.current_table2_entity = {}
                this.data_create = true
            },

            close() {
                this.$emit('close')
            },

            updateTipo(event) {
                console.log("choice:", event.target.value)
                // this.item['tipo'] = event.target.value;
                console.log(this.item['tipo'])
            },


            save_items() {
                this.$emit('saved_items', this.items)
            },

            async create(data, url) {
                try {
                    const res = await axios.post(url, data);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }
            },

            async select(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }
            },

            async select_all(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;

                } catch (error) {
                    console.error('Error getting data:', error);
                }

            },

            async update(url, data) {

                try {
                    const res = await axios.put(url, data);
                    console.log('Data successfully updated:', res.data);
                    return res.data.data;

                } catch (error) {
                    console.error('Error posting data:', error);
                }
            },

            async remove(url) {
                // console.log("Data:", data.id)
                try {
                    await axios.delete(url);
                    return true;
                } catch (error) {
                    console.error('Error deleting data:', error);
                }
            },

            open_generic_table(key) {
                console.log("open_generic_table:", key)
                this.model_type = key
                if (key == 'equipamento')
                    this.upTable_data = [...this.equipamentos]
                else
                    this.upTable_data = [...this.servicos]
            },

            create_entity(entity) {
                this.show_entity_list=false;
                this.entity = {}
                this.clear_inputs()
                this.downTable_data = []
                this.infoCard_data= {
                    nome:'',
                    morada:'',
                    email:'',
                    telefone:'',
                },
                console.log("create entity:", entity)

            },

            async list_entities(entity) {
                this.show_entity_list=!this.show_entity_list;

                if(this.show_entity_list){
                    
                    const res= await this.select_all(`${this.baseURl}/api/v1/${entity}/`);
                    if(res){
                        this.entities=res
        
                    }
        
        
                    console.log("list entity:", entity)
                }
            },

            close() {
                this.$emit('close')
            },

            handleInputChange(key) {
                if (key == 'quantidade' || key == 'desconto' || key == 'preco') {
                    this.calc_total();
                }
            },

            calc_total() {
                if(this.data.entity=='proposta'){
                    return
                }
                if(this.models_copy[this.model_type].desconto>1){
                    this.models_copy[this.model_type].desconto = 1
                    return
                }
                if (this.models_copy[this.model_type].quantidade == undefined || this.models_copy[this.model_type]?.valorUnitario == undefined) {
                    return
                }
                if (this.models_copy[this.model_type].desconto == undefined) {
                    this.models_copy[this.model_type].desconto = 0
                }

                const preco = this.models_copy[this.model_type].valorUnitario

                const quantidade = this.models_copy[this.model_type].quantidade
                const desconto = this.models_copy[this.model_type].desconto
                let subtotal = 0
                let total = 0
                subtotal =preco*(1 - desconto)
                
                if(this.data.entity=='faturafornecedor'){
                    this.models_copy[this.model_type].subTotal = subtotal
                }
                
                total = (quantidade * subtotal)
                this.models_copy[this.model_type].valorTotal = total
            },

            copyValues() {
                Object.keys(this.models_copy['db_model']).forEach((key) => {
                    if (this.models_copy[this.model_type][key] !== undefined) {
                    this.models_copy['db_model'][key] = this.models_copy[this.model_type][key];
                    }
                });

                
                Object.keys(this.models_copy['db_model']).forEach((key) => {
                        if (key.includes(this.model_type)) {
                            this.models_copy['db_model'][key] = this.current_table_entity.id;
                        }
                        if(key.toLowerCase().includes(this.data.entity)){
                            this.models_copy['db_model'][key] = this.entity.id;
                        }
                });
                
            },

            select_entity_data(item) {
            //this.entity = item
                this.infoCard_data = item
                
                
                //this.clear_inputs()
            },

            select_generic_data(item){
                console.log("item selected:",item)
                this.set_data_copy[this.generic_table_title]=item;
                this.show_generic_table=false;
            },

            open_set_generic_table(key){
                this.show_generic_table=true;
                this.generic_table_title=key;
                this.generic_table_data=this.types[key];
            }

        },

        watch: {
            data: {
                handler() {
                    this.clear_inputs();
                    this.set_data_copy=JSON.parse(JSON.stringify(this.set_data))

                },
                deep: true
            },
        
            'models_copy.db_model': { // Corrigido aqui
                handler(newValue) {
                    this.finalFaturaData = newValue;
                },
                deep: true
            },
        
            // model: {
            //     handler() {
            //         // console.log('cart updated')
            //         this.item = JSON.parse(JSON.stringify(this.model))
            //     },
            //     deep: true
            // }
        },
    }


</script>





<style scoped>
    .button-container {
        display: flex;
        flex-wrap: wrap;

        gap: 10px; /* Adjust the gap as needed */
    }

    .button-wrapper {
        flex: 1 1 calc(50% - 4.5px); /* 50% width minus the gap */
        max-width: calc(50% - 4.5px); /* Ensure max width is the same */
    }

</style>
